/** Inline loading for admin tab content (shell already gated auth). */
export function AdminModuleLoading() {
  return (
    <div className="at-admin-module-loading" role="status" aria-live="polite">
      <div className="at-admin-module-spinner" />
      <span>Loading…</span>
    </div>
  )
}
